<template>
  <div>
    <toolbar-view title="Шаблоны сообщений">
      <template v-slot:barActions>
        <v-btn icon @click="view = view===null ? 'search' : null;searchText=null">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-btn icon @click="view = view===null ? 'create' : null">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn icon @click="refresh()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
    </toolbar-view>
    <v-text-field v-show="view==='search'" v-model="searchText" class="mx-4 pt-2 mb-4"
                  clearable dense hide-details label="Введите текст для поиска..." outlined/>
    <v-sheet :max-height="height-48-(view==='search' ? 64 : 0)" class="overflow-y-auto">
      <progress-page v-if="state.loading && state.data.count===0"/>
      <div v-show="view==='create'" class="px-4 pt-2">
        <v-textarea v-model="createText" auto-grow class="mb-4" dense hide-details label="Текст" outlined rows="1"/>
        <v-row no-gutters>
          <v-col>
            <v-btn class="mr-2" depressed small @click="view=null">Отмена</v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn :loading="stateCreate.loadingUpdate" depressed small @click="create()">Создать</v-btn>
          </v-col>
        </v-row>
      </div>
      <v-list v-show="view===null || view==='search'" class="pa-0" dense>
        <div v-if="state.success && templates().length===0" class="text-center">
          <alert>Не найдено</alert>
        </div>
        <v-list-item
            v-for="(item, i) in templates()"
            :key="i"
            class="pa-0" @click="selectTemplate(item)"
        >
          <v-row no-gutters>
            <v-col class="py-2 px-4 body-2" cols="auto" v-html="$tools.nl2br(item.text)"></v-col>
            <v-col class="caption px-3 pb-3" cols="12">
              <btn-small-accept btn-class="mr-2" name="Удалить" @accept="remove(item.id)"/>
              <v-btn class="mr-2" depressed small @click.stop="sort(item.id, true)">
                <v-icon color="grey" small>mdi-chevron-up-circle</v-icon>
              </v-btn>
              <v-btn depressed small @click.stop="sort(item.id, false)">
                <v-icon color="grey" small>mdi-chevron-down-circle</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-divider/>
            </v-col>
          </v-row>
        </v-list-item>
      </v-list>
    </v-sheet>
  </div>
</template>

<script>
import BtnSmallAccept from "../../../../componentsV2/base/BtnSmallAccept.vue";
import Stater from "@/plugins/stater";
import axios from "axios";
import ToolbarView from "@/components/ToolbarView.vue";
import {Entity_DialogMessageTemplate} from "../../../../../EntityStoreCacheService";
import Alert from "@/componentsV2/base/Alert.vue";
import ProgressPage from "@/components/ProgressPage.vue";

export default {
  components: {ProgressPage, Alert, ToolbarView, BtnSmallAccept},
  props: ['items', 'chat', 'height'],
  data: () => ({
    state: new Stater({items: [], count: 0}),
    view: null,
    searchText: null,
    stateCreate: new Stater(),
    createText: null,
  }),
  mounted() {
    this.load();
  },
  methods: {
    load() {
      new Entity_DialogMessageTemplate()
          .selects(Entity_DialogMessageTemplate.id)
          .selects(Entity_DialogMessageTemplate.sort)
          .selects(Entity_DialogMessageTemplate.text)
          .order(Entity_DialogMessageTemplate.sort, true)
          .filterAnd([Entity_DialogMessageTemplate.entity, Entity_DialogMessageTemplate.status].join('.') + '=?', 'active')
          .addStateCallback((v) => this.state.setRequestBuilderState(v, false))
          .addStateCallback((v) => {
            if (v.success)
              this.$emit('update:items', v.items);
          })
          .request()
    },
    templates() {
      let arr = this.state.data.items;
      if (!this.$tools.isEmpty(this.searchText))
        arr = arr.filter(v => v.text.toLowerCase().includes(this.searchText.toLowerCase()))
      return arr;
    },
    create() {
      this.stateCreate.stateLoadingUpdate();
      axios.post('/napi/dialog/messageTemplate/', {
        text: this.createText
      }).then(() => {
        this.stateCreate.stateSuccess();
        this.view = null;
        this.createText = null;
        this.load();
      }).catch(() => {
        this.stateCreate.stateError();
      });
    },
    remove(id) {
      axios.put('/napi/dialog/messageTemplate/' + id + '/', {
        status: 'deleted'
      }).then(() => {
        this.load();
      });
    },
    sort(id, isUp) {
      this.stateCreate.stateLoadingUpdate();
      axios.put('/napi/dialog/messageTemplate/' + id + '/', {
        sortDirection: isUp ? 'up' : 'down',
      }).then(() => {
        this.stateCreate.stateSuccess();
        this.load();
      });
    },
    selectTemplate(item) {
      this.$emit('select', {
        id: item.id,
        text: item.text,
        textResult: item.text,
        textTags: [],
      })
    },
    refresh() {
      this.state = new Stater({items: [], count: 0});
      this.state.stateLoading()
      this.load();
    }
  }
}
</script>
